function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { LOAD_USER_REQUEST, LOAD_USER_SUCCESS, LOAD_USER_FAILURE } from '../ActionType';
export var getCurrentUser = function(state) {
    return _object_spread({}, state.user);
};
export default function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        data: null,
        loading: true,
        error: ''
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case LOAD_USER_REQUEST:
            {
                return {
                    data: null,
                    loading: true,
                    error: ''
                };
            }
        case LOAD_USER_SUCCESS:
            {
                var user = action.payload.user;
                if (!user) {
                    return _object_spread_props(_object_spread({}, state), {
                        loading: false,
                        error: '',
                        data: null
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    data: _object_spread({}, state.data, user),
                    loading: false,
                    error: ''
                });
            }
        case LOAD_USER_FAILURE:
            {
                var error = action.payload.error;
                return {
                    data: null,
                    loading: false,
                    error: error
                };
            }
        default:
            return state;
    }
}
